import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './FixedIncome.css';

const FixedIncome = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fixedIncomeArticles = [
    {
      id: 1,
      category: 'US TREASURIES',
      title: 'Treasury Yields Surge as Fed Signals Slower Rate Cut Pace',
      subtitle: '10-year yields hit highest level in three months as central bank maintains hawkish stance on inflation',
      
      date: 'January 23, 2026',
      time: '1 hour ago',
      image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&h=450&fit=crop',
      slug: 'treasury-yields-surge-fed-signals'
    },
    {
      id: 2,
      category: 'CORPORATE BONDS',
      title: 'Investment-Grade Bond Issuance Hits Record $45 Billion in January',
      subtitle: 'Companies rush to lock in rates before expected market volatility',
      date: 'January 23, 2026',
      time: '2 hours ago',
      
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=450&fit=crop',
      slug: 'investment-grade-bond-issuance-record'
    },
    {
      id: 3,
      category: 'EMERGING MARKETS',
      title: 'Emerging Market Debt Rallies as Dollar Weakens',
      subtitle: 'Asian and Latin American bonds see strong inflows amid risk-on sentiment',
      date: 'January 23, 2026',
      time: '3 hours ago',
      
      image: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=800&h=450&fit=crop',
      slug: 'emerging-market-debt-rallies'
    },
    {
      id: 4,
      category: 'MUNICIPAL BONDS',
      title: 'California Launches $8 Billion Green Bond Offering',
      subtitle: 'Largest state green bond issuance aims to fund renewable energy projects',
      date: 'January 23, 2026',
      time: '4 hours ago',
      image: 'https://images.unsplash.com/photo-1473186578172-c141e6798cf4?w=800&h=450&fit=crop',
      slug: 'california-green-bond-offering'
    }
  ];

  const fixedIncomeListLeft = [
    {
      id: 11,
      title: 'US Treasury 10-Year Yield Climbs to 4.65% on Hawkish Fed Comments',
      time: '3 Feb 2026 11:30 AM',
      image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=200&h=200&fit=crop&q=80',
      slug: 'treasury-10year-yield-climbs'
    },
    {
      id: 12,
      title: 'Corporate Bond Sales Hit $85 Billion in January, Best Start Since 2021',
      time: '3 Feb 2026 9:15 AM',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=200&h=200&fit=crop&q=80',
      slug: 'corporate-bond-sales-january'
    },
    {
      id: 13,
      title: 'Emerging Market Bonds Rally as Dollar Weakness Continues',
      time: '2 Feb 2026 3:45 PM',
      image: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=200&h=200&fit=crop&q=80',
      slug: 'emerging-market-bonds-rally'
    },
    {
      id: 14,
      title: 'Municipal Bond Yields Drop to Lowest Level in Three Months',
      time: '2 Feb 2026 1:20 PM',
      image: 'https://images.unsplash.com/photo-1473186578172-c141e6798cf4?w=200&h=200&fit=crop&q=80',
      slug: 'municipal-bond-yields-drop'
    },
    {
      id: 15,
      title: 'High-Yield Bond Spreads Narrow as Credit Quality Improves',
      time: '2 Feb 2026 10:00 AM',
      image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=200&h=200&fit=crop&q=80',
      slug: 'high-yield-spreads-narrow'
    },
    {
      id: 16,
      title: 'European Central Bank Announces €50 Billion Bond Buying Program',
      time: '1 Feb 2026 2:30 PM',
      image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=200&h=200&fit=crop&q=80',
      slug: 'ecb-bond-buying-program'
    },
    {
      id: 17,
      title: 'Japan Sells Record $120 Billion in Government Bonds',
      time: '1 Feb 2026 8:45 AM',
      image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=200&h=200&fit=crop&q=80',
      slug: 'japan-government-bonds-record'
    },
    {
      id: 18,
      title: 'Investment Grade Credit Spreads Tighten to Pre-Pandemic Levels',
      time: '31 Jan 2026 4:15 PM',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=200&h=200&fit=crop&q=80',
      slug: 'investment-grade-spreads-tighten'
    },
    {
      id: 19,
      title: 'Inflation-Linked Bonds Attract Record $8 Billion in Weekly Inflows',
      time: '31 Jan 2026 11:00 AM',
      image: 'https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?w=200&h=200&fit=crop&q=80',
      slug: 'inflation-linked-bonds-inflows'
    },
    {
      id: 20,
      title: 'UK Gilt Yields Rise as Bank of England Holds Rates Steady',
      time: '30 Jan 2026 2:00 PM',
      image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=200&h=200&fit=crop&q=80',
      slug: 'uk-gilt-yields-rise'
    }
  ];

  const fixedIncomeListRight = [
    {
      id: 21,
      title: 'Chinese Government Bonds See Strong Foreign Demand',
      time: '3 Feb 2026 10:45 AM',
      image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=200&h=200&fit=crop&q=80',
      slug: 'chinese-bonds-foreign-demand'
    },
    {
      id: 22,
      title: 'Convertible Bond Issuance Reaches $45 Billion in 2026',
      time: '3 Feb 2026 8:30 AM',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=200&h=200&fit=crop&q=80',
      slug: 'convertible-bond-issuance-2026'
    },
    {
      id: 23,
      title: 'Asset-Backed Securities Market Shows Signs of Recovery',
      time: '2 Feb 2026 4:00 PM',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=200&h=200&fit=crop&q=80',
      slug: 'abs-market-recovery'
    },
    {
      id: 24,
      title: 'Green Bonds Surpass $200 Billion in Global Issuance',
      time: '2 Feb 2026 12:30 PM',
      image: 'https://images.unsplash.com/photo-1473186578172-c141e6798cf4?w=200&h=200&fit=crop&q=80',
      slug: 'green-bonds-global-issuance'
    },
    {
      id: 25,
      title: 'Mortgage-Backed Securities Yield Premium Widens',
      time: '2 Feb 2026 9:00 AM',
      image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=200&h=200&fit=crop&q=80',
      slug: 'mbs-yield-premium-widens'
    },
    {
      id: 26,
      title: 'Australian Government Bonds Rally on Rate Cut Speculation',
      time: '1 Feb 2026 3:15 PM',
      image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=200&h=200&fit=crop&q=80',
      slug: 'australian-bonds-rally'
    },
    {
      id: 27,
      title: 'Distressed Debt Fund Raises $3.5 Billion for Opportunistic Buying',
      time: '1 Feb 2026 10:30 AM',
      image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=200&h=200&fit=crop&q=80',
      slug: 'distressed-debt-fund-raise'
    },
    {
      id: 28,
      title: 'Credit Default Swap Spreads Decline Across All Sectors',
      time: '31 Jan 2026 5:00 PM',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=200&h=200&fit=crop&q=80',
      slug: 'cds-spreads-decline'
    },
    {
      id: 29,
      title: 'Floating Rate Notes Gain Popularity in Rising Rate Environment',
      time: '31 Jan 2026 1:45 PM',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=200&h=200&fit=crop&q=80',
      slug: 'floating-rate-notes-popularity'
    },
    {
      id: 30,
      title: 'Structured Credit Products See Renewed Investor Interest',
      time: '30 Jan 2026 3:30 PM',
      image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=200&h=200&fit=crop&q=80',
      slug: 'structured-credit-interest'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Fixed Income News & Analysis - Bonds, Treasuries, Rates | Redbox Global</title>
        <meta name="description" content="Latest fixed income market news, bond yields, treasury rates, and credit analysis. Coverage of corporate bonds, municipal bonds, and sovereign debt." />
        <meta name="keywords" content="fixed income, bonds, treasuries, bond yields, corporate bonds, municipal bonds, treasury rates, credit markets, sovereign debt, bond market news" />
        
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Fixed Income News & Analysis - Redbox Global" />
        <meta property="og:description" content="Latest fixed income market news, bond yields, treasury rates, and comprehensive credit analysis from Redbox Global." />
        <meta property="og:url" content="https://redboxglobal.com/markets/fixed-income" />
        <meta property="og:image" content="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&h=630&fit=crop" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Fixed Income News & Analysis - Redbox Global" />
        <meta name="twitter:description" content="Latest fixed income market news, bond yields, treasury rates, and comprehensive credit analysis." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&h=630&fit=crop" />
        
        <link rel="canonical" href="https://redboxglobal.com/markets/fixed-income" />
      </Helmet>

      <div className="fixed-income-page">
        <div className="container">
          {/* Breadcrumb */}
          <nav className="breadcrumb">
            <Link to="/">Home</Link>
            <span className="separator">/</span>
            <Link to="/markets">Markets</Link>
            <span className="separator">/</span>
            <span className="current">Fixed Income</span>
          </nav>

          {/* Page Header */}
          <header className="page-header">
            <h1 className="page-title">Fixed Income</h1>
            <p className="page-description">
              Comprehensive coverage of bond markets, treasury yields, credit analysis, and fixed income investment strategies from around the globe.
            </p>
          </header>






          {/* Featured Swiper Slider */}
          <section className="featured-section">
            <Swiper
              modules={[Autoplay, Pagination]}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              pagination={{ clickable: true }}
              loop
              className="fixed-income-swiper"
            >
              {fixedIncomeArticles.map((article) => (
                <SwiperSlide key={article.id}>
                  <article className="featured-article">
                    <Link to={`/article/${article.slug}`} className="featured-link">
                      <div className="featured-image">
                        <img src={article.image} alt={article.title} />
                        <span className="featured-category">{article.category}</span>
                      </div>
                    </Link>
                    <div className="featured-content">
                      <h2 className="featured-title">
                        <Link to={`/article/${article.slug}`}>{article.title}</Link>
                      </h2>
                      <p className="featured-subtitle">{article.subtitle}</p>
                      <div className="article-meta">
                        <span className="date">{article.time}</span>
                      </div>
                    </div>
                  </article>
                </SwiperSlide>
              ))}
            </Swiper>
          </section>

          {/* TWO-COLUMN FIXED INCOME LIST VIEW */}
          <section className="bloomberg-two-columns">
            {/* Left Column */}
            <div className="bloomberg-column">
              {fixedIncomeListLeft.map((item) => (
                <article key={item.id} className="bloomberg-item">
                  <Link to={`/article/${item.slug}`} className="bloomberg-link">
                    <div className="bloomberg-thumb">
                      <img src={item.image} alt={item.title} />
                    </div>
                    <div className="bloomberg-text">
                      <h3 className="bloomberg-title">{item.title}</h3>
                      <span className="bloomberg-time">{item.time}</span>
                    </div>
                  </Link>
                </article>
              ))}
            </div>

            {/* Right Column */}
            <div className="bloomberg-column">
              {fixedIncomeListRight.map((item) => (
                <article key={item.id} className="bloomberg-item">
                  <Link to={`/article/${item.slug}`} className="bloomberg-link">
                    <div className="bloomberg-thumb">
                      <img src={item.image} alt={item.title} />
                    </div>
                    <div className="bloomberg-text">
                      <h3 className="bloomberg-title">{item.title}</h3>
                      <span className="bloomberg-time">{item.time}</span>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
          </section>
</div>
      </div>
    </>
  );
};

export default FixedIncome;
